var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolDarkBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 140 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.38 0L25.23 58.16V78.81L104.04 0H83.38ZM25.22 45.81L39.28 31.75V0H0V137.07L14.51 122.56V13.39H25.23V45.81H25.22Z",
    fill: "#1C2B57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.89 73.6401L25.22 91.3001V111.95L42.89 94.2901L85.67 137.07H106.32L43 73.7501L42.89 73.6401Z",
    fill: "#209DD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.79 67.39L137.18 0H116.53L49.14 67.39L118.82 137.07H139.47L69.79 67.39Z",
    fill: "#209DD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDarkBlue);
export default __webpack_public_path__ + "static/media/Symbol_DarkBlue.149f7cfa6f4abf19d379ff670557c627.svg";
export { ForwardRef as ReactComponent };